export const REPORT_PRINTABLE_RENDERING_STATVALUEINCLUSION_TYPE_BOTH = 0 // Formatted + Raw
export const REPORT_PRINTABLE_RENDERING_STATVALUEINCLUSION_TYPE_MAIN = 1 // Formatted Display Values Only (Text)
export const REPORT_PRINTABLE_RENDERING_STATVALUEINCLUSION_TYPE_ALTERNATIVE = 2 // Raw Value Only
